import { Box } from "@material-ui/core"
import { useLocation, useNavigate } from "react-router-dom"
import NCText from "../shared/NCText"
import { makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles(() => ({
  text: {}
}))
const TopNavBar = ({ lastLabel }) => {
  const { pathname } = useLocation()
  const { t } = useTranslation();
  const nav = useNavigate()
  const cls = useStyles()

  const renderPath = () => {
    let pathParts = pathname.split("/")
    pathParts.splice(0, 1)
    let prevPath = ""
    return pathParts.reduce((acc, path, index) => {
      let obj = { path, name: path }
      obj.name = obj.name.replace(/-/g, " ")
      obj.name = obj.name.charAt(0).toUpperCase() + obj.name.slice(1)
      const isLast = index === pathParts.length - 1
      if (isLast && lastLabel) {
        obj.name = index ? ` / ${lastLabel}` : lastLabel
      } else if (index) {
        obj.name = ` / ${t(obj.name)}`
      } else {
        obj.name = t(obj.name)
      }
      obj.path = `${prevPath}/${path}`
      prevPath = obj.path
      acc.push(obj)
      return acc
    }, [])
  }

  return (
    <Box
      bgcolor={"#F3FAFC"}
      px={2}
      py={1}
      mb={2}
      display={"flex"}
      alignItems={"center"}
      margin="0px 0px 16px 0px"
      border={1}
      borderColor="grey.300"
      borderRadius={8}
    >
      {renderPath().map((item, idx) => {
        return pathname === item.path ? (
          <Box key={idx} className={cls.text} ml={1}>
            <NCText>{item.name}</NCText>
          </Box>
        ) : (
          <Box
            key={idx}
            className={cls.text}
            color={"#1EAAC4"}
            style={{ cursor: "pointer" }}
          >
            <NCText onClick={() => nav(item.path)}>{item.name}</NCText>
          </Box>
        )
      })}
    </Box>
  )
}

export default TopNavBar
